import React, { Fragment, useEffect, useState } from "react";
import { useLesson } from "../../../../hooks/useLesson";
import { useFilterConfigStore } from "../../../../stores/filterConfig";
import { useLessonStore } from "../../../../stores/lessonStore";
import { useNewSubjectStore } from "../../../../stores/newSubjectStore";
import { useParams } from "react-router-dom";
import { ILesson } from "../../../../../../core/models/disciplines";
import BrainLoadingWrapper from "../../../../../../core/components/molecules/BrainLoading";
import LessonCard from "../../lessonCard";
import { useDisciplinesAuxStore } from "../../../../stores/auxStore";
import { IResponseFavorite } from "../../../../hooks/useContentFavorite";
import { useLessonContentStore } from "../../../../stores/lessonContentStore";
import { useFinishLesson } from "../../../../../../core/hooks/useFinishLesson";
import getSubjectByFilter from '../../../../../../core/commom/getSubjectByFilter';

interface IContentModalLesson {
  onClose: () => void;
}

const ContentModalLesson: React.FC<IContentModalLesson> = ({ onClose }) => {
  const { module, discipline, slug } = useParams();

  const { mutate: finishLesson, isLoading, isSuccess} = useFinishLesson();

  const { mutate, isPending } = useLesson();
  const { selectedSubjects } = useNewSubjectStore();
  const { lessons } = useLessonStore();
  const { type, status, favorites } = useFilterConfigStore();
  const { setPlaylistResultNumber } = useDisciplinesAuxStore();
  const { setAllLessons } = useLessonContentStore();

  const [main, setMain] = useState<ILesson[]>([])
  const [knowmore, setKnowmore] = useState<ILesson[]>([])
  const [summary, setSummary] = useState<ILesson[]>([])

  useEffect(() => {
    if(lessons?.length > 0) {
      filterLessons()
    } 
  }, [lessons, selectedSubjects])

  useEffect(() => {
    if(lessons?.length > 0) {
      filterLessons();
    }
  }, [type, status, favorites])

  useEffect(() => {
    if(module) {
      mutate(module)
    }
  }, []);

  useEffect(() => {
    if(isSuccess && module) {
      mutate(module);
    }
  }, [isLoading])

  const callbackFav = (data: IResponseFavorite) => {
    if(data.ok && module) {
      mutate(module)
    }
  }

  const filterLessons = () => {
    if(lessons?.length > 0) {
      const aux = [...lessons];
      let filteredData = aux;
      
      if(selectedSubjects?.length > 0) {
        filteredData = filteredData.filter((it) => selectedSubjects.includes(it.subjects[0].slug))
      }

      if(type?.length > 0) {
        filteredData = filteredData.filter((it) => type.includes(it.type))
      }

      if(status?.length === 1) {
        if(status.includes('not_played')) {
          filteredData = filteredData.filter((it) => !it.done)
        } else {
          filteredData = filteredData.filter((it) => it.done)
        }
      }

      if(favorites) {
        filteredData = filteredData.filter((it) => it.favorite)
      }

      const mainA: ILesson[] = [], knowmoreA: ILesson[] = [], summaryA: ILesson[] = [];

      filteredData.map((it) => {
        if(it.type === 'knowmore') {
          knowmoreA.push(it);
        } else if(it.type === 'main') {
          mainA.push(it);
        } else {
          summaryA.push(it)
        }
      })

      setMain(mainA);
      setKnowmore(knowmoreA);
      setSummary(summaryA)
      setPlaylistResultNumber(filteredData?.length);
      setAllLessons(filteredData);
    }
  }

  function dispatchSetContentAsDoneEvent(id: string) {
    const setContentAsDone = new CustomEvent('setContentAsDone', {
      detail: {
        contentId: id,
      },
    });
    window.dispatchEvent(setContentAsDone);
  }

  const onFinish = (id: string, slug: string) => {
    if (slug) {
      finishLesson({ slug, body: null });
      dispatchSetContentAsDoneEvent(id);
    }
  };

  if(isPending) {
    return <BrainLoadingWrapper />
  }

  return (
    <Fragment>
      {main?.map((it, i) => (
        <LessonCard
          key={i}
          lesson={it}
          discipline={discipline ?? ''}
          module={module ?? ''}
          subjectSlug={it.subjects[0].slug}
          subject={getSubjectByFilter(it.subjects, selectedSubjects)}
          slug={slug ?? ''}
          done={it.done}
          favorite={it.favorite}
          onClose={onClose}
          onDone={(id, slug) => onFinish(id, slug)}
          callback={(data: IResponseFavorite) => callbackFav(data)}
        />
      ))}
      {summary?.map((it, i) => (
        <LessonCard
          key={i}
          lesson={it}
          discipline={discipline ?? ''}
          module={module ?? ''}
          subjectSlug={it.subjects[0].slug}
          subject={getSubjectByFilter(it.subjects, selectedSubjects)}
          slug={slug ?? ''}
          done={it.done}
          favorite={it.favorite}
          onDone={(id, slug) => onFinish(id, slug)}
          onClose={onClose}
          callback={(data: IResponseFavorite) => callbackFav(data)}
        />
      ))}
      {knowmore?.map((it, i) => (
        <LessonCard
          key={i}
          lesson={it}
          discipline={discipline ?? ''}
          module={module ?? ''}
          subjectSlug={it.subjects[0].slug}
          subject={getSubjectByFilter(it.subjects, selectedSubjects)}
          slug={slug ?? ''}
          done={it.done}
          favorite={it.favorite}
          onDone={(id, slug) => onFinish(id, slug)}
          onClose={onClose}
          callback={(data: IResponseFavorite) => callbackFav(data)}
        />
      ))}
    </Fragment>
  )
}

export default ContentModalLesson;